import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import InlineList from 'components/InlineList';
import { TooltipPillWithCount, GoalPill } from 'components/Pill';
import Text from 'components/Text';
import ViewMoreText from 'components/ViewMoreText';
import FriendlyDuration from 'components/FriendlyDuration';
import config from 'utils/config';
import getContentProgress from 'utils/asset/getContentProgress';
import ContentProgressCircle from 'components/ContentProgressCircle';
export default function InfoSection(_ref) {
  var playlist = _ref.playlist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = playlist.id,
    name = playlist.name,
    completionTime = playlist.completionTime,
    completionRate = playlist.completionRate,
    description = playlist.description,
    commentCount = playlist.commentCount,
    commentCountUser = playlist.commentCountUser,
    userContentStatus = playlist.userContentStatus,
    goal = playlist.goal,
    contentCount = playlist.contentCount;
  var progress = getContentProgress({
    isPlaylist: true,
    userContentStatus: userContentStatus,
    completionRate: completionRate
  });
  if (!id) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    dimmed: true,
    mb: "m"
  }, /*#__PURE__*/React.createElement(InlineList, {
    splitBy: "dot"
  }, t('content_type_playlist'), contentCount > 0 && t('playlist_item_count', {
    count: contentCount
  }), completionTime > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FriendlyDuration, {
    value: completionTime * 60
  }), ' ', t('playlist_duration')), contentCount > 0 && /*#__PURE__*/React.createElement(ContentProgressCircle, {
    progress: progress,
    contentName: name,
    infoReadout: "full"
  }), goal && /*#__PURE__*/React.createElement(GoalPill, {
    goal: goal
  }), config.enableComments && !!commentCount && /*#__PURE__*/React.createElement(TooltipPillWithCount, {
    "data-qa": "comment-count-pill",
    icon: "chat",
    highlightIcon: commentCountUser > 0,
    count: commentCount
  }))), description && /*#__PURE__*/React.createElement(Text, {
    lineHeight: 1.9,
    mb: "m",
    overflow: "wrap",
    as: "div"
  }, /*#__PURE__*/React.createElement(ViewMoreText, {
    content: description,
    maxLength: 180
  })));
}